import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getDocumentViewData } from '@/utils/document';

export const documentViewRoute: RouteConfig = {
  name: 'documentView',
  path: 'view',
  component: () => import(/* webpackChunkName: "DocumentView" */ '@/views/mainRoute/document/details/View.vue'),
  beforeEnter: (to, from, next) => {
    getDocumentViewData(to)
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: Errors.DOCUMENT_CANNOT_GET }));
  }
};
